import React, {useState,useEffect} from 'react';
//import useStyles from './Styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
//import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
//import TextField from '@mui/material/TextField';
//import InputAdornment from '@mui/material/InputAdornment';
//import TwitterIcon from '@mui/icons-material/Twitter';
//import InstagramIcon from '@mui/icons-material/Instagram';
//import FacebookIcon from '@mui/icons-material/Facebook';
import PortraitIcon from '@mui/icons-material/Portrait';
import AddIcon from '@mui/icons-material/Add';
import {Inc,Dataset,DataErrorset,Owner,OwnerProfile,OwnerNameLengthMax,OwnerNameLengthMin,CompanyNameLengthMax,CompanyNameLengthMin,OwnerProfileLengthMax,SnsAccountLengthMin,SnsAccountLengthMax,FediverseAccountLengthMax} from './Inc';
import TwinInputString from './TwinInputString';
import InputString from './InputString';
import DropImage from './DropImage';
import DropImageLight from './DropImageLight';
import Yesno from './Yesno';
import Ajax from './Ajax';
import Loading from './Loading';
import Toast from './Toast';
import RowData from './RowData';
import Problems from './Problems';
import {Tools} from './Tools';
//import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {ThreadsIcon,MastodonIcon,MisskeyIcon,TumblrIcon,FacebookIcon,TwitterIcon,InstagramIcon} from './AdditionalIcons';

interface ProfileInputProps {
	isOpen:boolean,
	ownerId:number,
	customerId:number,
	switchId:number,
    //profile:OwnerProfile,
	//owner:Owner,
	close(updated:boolean,profile:OwnerProfile,owner:any):void,
}

interface ProfileInputParams {
    links:DataErrorset[],
}

//let errors:string[] = [];
//let newImgs:{ [key: string]: string; } = {};

const ProfileInput = (props:ProfileInputProps)=> {
    Ajax.setEditorId( props.ownerId );
    //const classes = useStyles();
    const defParam:ProfileInputParams = {
        links:[],
    }
	const defStates = {
        profile: Inc.defaultOwnerProfile(),
		owner: Inc.defaultOwner(),
		params: defParam,
		paramErrors: [] as string[],
		hasParamError: false,
		problems: [] as string[],
		newImgs: {} as {[key: string]: string},
        ready: false,
        yesno: "",
        toast: "",
		hasError: true,
		errors: [] as string[],
        isLoading: true,
		isProcessing: false,
    };
    const [states,setStates] = useState(defStates);

	const load = ()=>{
		setStates({...states,isLoading:true});
		Ajax.send("profile/get",{mode:"edit",customer_id:props.customerId},(res:any)=>{
			//console.log(res.profile);
			if( res.ok ){
				const profile = Inc.convOwnerProfile(res.profile);
				const owner = Tools.convOwner(res.owner,true);
				const links:DataErrorset[] = [];
				if( profile.links.length>0 ){
					for( let i=0; i<profile.links.length; i++ ){
						const link:DataErrorset = {
							id: profile.links[i].id,
							label: profile.links[i].label,
							error: false,
						}
						links.push( link );
					}
				} else {
					links.push({
						id:"",
						label:"",
						error:false,
					});
				}

				let errors = [] as string[];
				if( profile.owner_name==='' ){
					errors.push("owner_name");
					errors.push("kana");
				}
				setStates({
					...defStates,
					isLoading:false,
					profile:profile,
					owner:owner,
					newImgs:{},
					hasError:errors.length>0,
					errors:errors,
					params:{links:links}
				});
				//setStates({...states,"isLoading":false,"isInput":false,"profile":Inc.convOwnerProfile(res.profile)})
			}
		});
	}
	const onChangeString = (name:keyof OwnerProfile) => (value: string,hasError: boolean) => {
		//const item = {...states.item,[name]:value};
		//console.log(name,value,hasError);
		validateProfile({...states.profile,[name]:value},name,hasError);
	};
    const onChangeSnss = (name:string) => (value: string,hasError: boolean) => {
		//console.log("onChangeSnss",name,value);
        //const snss = [...states.profile.snss];
		const snss = [] as Dataset[];
		states.profile.snss.forEach((data:Dataset,index:number)=>{
            snss.push({
                id: data.id,
                label: data.label,
            });
		});

        let flag = false;
        for( let i=0 ; i<snss.length ; i++ ){
            //if( snss[i] ){
                if( snss[i].id===name ){
                    snss[i].label = value;
                    flag = true;
                }
            //}
        }
        if(!flag){
            snss.push({
                id: name,
                label: value,
            });
        }
        //setStates({...states,"profile":{...states.profile,snss:snss}})
		validateProfile({...states.profile,snss:snss},'snss',hasError);
    }

	const stripurl = (value:string)=>{
		value = value.replace("https://twitter.com/","");
		value = value.replace("https://x.com/","");
		value = value.replace("https://instagram.com/","");
		value = value.replace("https://www.instagram.com/","");
		value = value.replace("https://facebook.com/","");
		value = value.replace("https://www.facebook.com/","");
		value = value.replace(/\/+/g,"");

		if( value.indexOf("?")>0 ){
			const sp = value.split("?");
			value = sp[0];
		}
		return value;
	}

    const changeParamTwin = (id:keyof ProfileInputParams,index:number,value1:string,value2:string,hasError:boolean)=>{
		if( id!=='links' ){
			return;
		}
        let data = states.params[id];
        data[index] = {
            id: value1,
            label: value2,
			error: hasError,
        };
		hasError = false;
		for( let i=0; i<data.length; i++ ){
			if( data[i] ){
				if( data[i].error ){
					hasError = true;
				}
			}
		}
		const newParams = {...states.params,[id]:data};
		validateParam(newParams,id,hasError);
    }
	const validateProfile= (profile:OwnerProfile,name:string,hasError:boolean)=>{
		let errors = [...states.errors];
		const index = errors.indexOf(name);
		if( index>=0 ){
			if(!hasError){
				errors.splice(index, 1);
			}
		} else {
			if(hasError){
				errors.push(name);
			}
		}
		setStates({...states,profile:profile,errors:errors,hasError:errors.length>0});
	}
	const validateParam = (params:ProfileInputParams,name:string,hasError:boolean)=>{
		let errors = [...states.paramErrors];
		const index = errors.indexOf(name);
		if( index>=0 ){
			if(!hasError){
				errors.splice(index, 1);
			}
		} else {
			if(hasError){
				errors.push(name);
			}
		}
		setStates({...states,params:params,paramErrors:errors,hasParamError:errors.length>0});
	}
    const changeImage = (id:string,src:string)=>{
        //newImgs[ id ] = src;

		if (id.substring(0, 5) === "photo") {
			setStates(prev => {
				const newImgs = { ...prev.newImgs, [id]:src };
				let photo_ids = Tools.treatPhotos([...prev.profile.photo_ids],id,src,newImgs,3);
				return {
					...prev,
					profile: {...prev.profile, photo_ids: photo_ids},
					newImgs: newImgs,
				};
			});
		} else {
			setStates(prev => {
				const newImgs = { ...prev.newImgs, [id]:src };
				return {
					...prev,
					newImgs: newImgs,
				};
			});
		}
	}
    const confirm = async ()=>{
		if( states.isProcessing ){
			return;
		}

		setStates({...states,isProcessing:true});
        //console.log("states",states);
        //console.log("itemImgs",itemImgs);
        //console.log("errors",errors);
		const isUnique = await checkOwnerName(states.profile.owner_name);

		if( isUnique && !states.hasError && !states.hasParamError ){
			setStates(prev=>({...states,yesno:"この内容で登録します。\nよろしいですか？"}));
			return;
		}

		const errors = [] as string[];
		if( states.hasError ){
			for( let i=0; i<states.errors.length; i++ ){
				let mes = '';
				if(states.errors[i]==='owner_name'){
					mes = '作家名';
				} else if(states.errors[i]==='img_id'){
					mes = 'メイン画像';
				} else if(states.errors[i]==='header_img_id'){
					mes = 'ヘッダー画像';
				} else if(states.errors[i]==='kana'){
					mes = '作家名（かな）';
				} else if(states.errors[i]==='company_name'){
					mes = '団体名';
				} else if(states.errors[i]==='profile'){
					mes = '紹介文';
				} else if(states.errors[i]==='page_id'){
					mes = 'シリーズ';
				} else if(states.errors[i]==='snss'){
					mes = 'SNS';
				}
				if( mes!=='' ){
					errors.push(mes);
				}
			}
		}
		if( states.hasParamError ){
			for( let i=0; i<states.paramErrors.length; i++ ){
				let mes = '';
				if(states.paramErrors[i]==='links'){
					mes = 'リンク';
				} else if(states.paramErrors[i]==='photo_ids'){
					mes = '追加画像';
				}
				if( mes!=='' ){
					errors.push(mes);
				}
			}
		}
		if( !isUnique ){
			let error = 'この作家名はすでに使われています';
			errors.push(error);
		}
		if( errors.length===0 ){
			let tmp1 = '';
			if( states.errors.length>0 ){
				tmp1 = states.errors.join("/");
			}
			let tmp2 = '';
			if( states.paramErrors.length>0 ){
				tmp2 = states.paramErrors.join("/");
			}
			errors.push('原因不明（システム側に異常の可能性あり）\n'+tmp1+':'+tmp2+'');
		}

		setStates({...states,problems:errors,isProcessing:false});
		return;

    }
	const close = ()=>{
		setStates(defStates);
		//console.log(props.profile.snss);
		props.close(false,states.profile,{});
		//props.close(false,Inc.defaultOwnerProfile(),{});
	}

    const checkOwnerName = async (value:string)=>{
        //console.log("blur");
        const res = await Ajax.sendAwait("profile/name",{owner_name:value,owner_id:props.ownerId});
		if( res.used ){
			return false;
		}
		return true;
    }
    const yes = ()=>{
		//console.log(states.profile);
        setStates({...states,isLoading:true});
        Ajax.send("profile/do",{
			profile:states.profile,
			params:states.params,
			new_imgs:states.newImgs,
			switch_id:props.switchId,
			customer_id:states.owner.customer.customer_id
		},(res:any)=>{
            if( res.ok ){
                props.close(true,Inc.convOwnerProfile(res.profile),res.owner);
                setStates({...states,isLoading:false,isProcessing:false});
            } else {
                setStates({...states,yesno:"",toast:"登録できませんでした",isLoading:false,isProcessing:false});
            }
        },(err:any)=>{
            setStates({...states,yesno:"",toast:"登録できませんでした",isLoading:false,isProcessing:false});
        });
    }
    const no = ()=>{
        setStates({...states,yesno:"",problems:[]});
    }
    const closeToast = ()=>{
        setStates({...states,toast:""});
    }
	const addBlankLink = ()=>{
		if( states.params.links.length>3 ){
			return;
		}
		const links = [...states.params.links];
		const link = {
			id: '',
			label: '',
			error: false,
		} as DataErrorset;
		links.push(link);
		setStates({...states,params:{...states.params,links:links}});
	}

    useEffect( ()=>{
		if(!props.isOpen){
			return;
		}
		load();
		window.scrollTo(0,0);
    },[props.isOpen]);

    //useEffect( ()=>{
    //    newImgs = {};
    //    if( props.owner.owner_id>0 ){
    //        Ajax.send("profile/get",{},(res:any)=>{
    //            //console.log(res);
    //            if( res.ok ){
    //                setStates({...states,"isLoading":false,"profile":Inc.convOwnerProfile(res.profile)})
    //            }
    //        });
    //    } else {
    //        setStates({...states,"profile":Inc.defaultOwnerProfile(),"isLoading":false});
    //    }
    //} ,[]);

	if( !props.isOpen ){
		return null;
	}

    if( states.isLoading ){
        return (
            <Loading isLoading={true}/>
        )
    }

    // let photo_ids:number[] = [];
    // for( let i=0 ; i<3 ; i++ ){
    //     if( states.profile.photo_ids[i] ){
    //         photo_ids.push(states.profile.photo_ids[i]);
    //     } else {
    //         photo_ids.push(0);
    //     }
    // }

    // let links:DataErrorset[] = [];
    // for( let i=0 ; i<4 ; i++ ){
    //     if( states.params.links[i] ){
    //         links.push(states.params.links[i]);
    //     } else {
    //         links.push({
    //             id:"",
    //             label:"",
	// 			error:false,
    //         });
    //     }
    // }

    let snss:{ [key: string]: string; } = {}
    for( let i=0 ; i<Inc.snsNames.length ; i++ ){
        snss[ Inc.snsNames[i] ] = "";
    }
    for( let i=0 ; i<Inc.snsNames.length ; i++ ){
        if( states.profile.snss[i] ){
            snss[ states.profile.snss[i].id ] = states.profile.snss[i].label;
        }
    }

    //font-awesome(SNS logo)
    //library.add(fab);

	return (
		<Dialog
			fullScreen
			open={props.isOpen}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableEscapeKeyDown={true}
		>
			<DialogContent style={{padding:"0",margin:"0",backgroundColor:'#F5F5F5'}}>

				<AppBar position="fixed" style={{backgroundColor:`#FFFFFF`}}>
					<Toolbar variant="dense" style={{backgroundColor:`#FFFFFF`}}>
						<div style={{color:'#333333',flex:'1'}}><PortraitIcon style={{verticalAlign:'middle',marginRight:'0.25em'}}/><span style={{verticalAlign:'middle'}}>プロフィール</span><span style={{verticalAlign:'middle',fontSize:'80%'}}>（作家）</span></div>
						<Button variant="text" color="primary" onClick={close} style={{marginRight:`0.5em`}}>もどる</Button>
						{(!states.hasError && !states.hasParamError) ? (
						<Button variant="contained" color="primary" onClick={confirm}>登録</Button>
						):(
						<Button variant="contained" color="info" onClick={confirm}>登録</Button>
						)}
					</Toolbar>
				</AppBar>

				<div style={{maxWidth:'1280px',width:'100%',boxSizing:'border-box',padding:"4em 1em",margin:'0 auto',backgroundColor:'#FFFFFF'}}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={3} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<Typography variant="h6">ヘッダー画像</Typography>
							<div className="formExplanation">
								作家ページや作家さんからのお知らせページなどでヘッダーとして表示される画像です<br/>
								<div className="formHint">
									※PNG/JPEG/GIFでJPEGに変換して保存されます<br/>
									※幅1280px×高400pxを目安として自動的にトリミングされます
								</div>

							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<div style={{textAlign:"center"}}>
								<DropImage noHelper={true} owner_id={props.ownerId} img_id={states.profile.header_img_id} id="header_img" change={changeImage}/>
							</div>
							<div className="formHelper">
							画像を登録するには「ここに追加」をクリックもしくは画像をドラッグして下さい<br/>
							</div>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						<Grid item xs={12} sm={3} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<Typography variant="h6">メイン画像</Typography>
							<div className="formExplanation">
								プロフィール画像としてあちこちで使われる画像です<br/>
								実際に表示されるサイズは100x100pxですが、<b>200×200px</b>の画像を用意するとキレイに表示されます<br/>
								<div className="formHint">
									※PNG/JPEG/GIFでJPEGに変換して保存されます<br/>
									※200pxより大きい場合は自動的に縮小されます<br/>
								</div>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<div style={{width:'200px',height:'200px',boxSizing:'border-box',fontSize:'80%'}}>
								<DropImage noHelper={true} owner_id={props.ownerId} img_id={states.profile.img_id} id="img" change={changeImage}/>
							</div>
							<div className="formHelper">
								画像を登録するには「ここに追加」をクリックもしくは画像をドラッグして下さい<br/>
							</div>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						<Grid item xs={12} sm={3} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<Typography variant="h6">作家名<span className="formRequired">必須</span></Typography>
							<div className="formExplanation">
								ほかの作家さんと同じ名前にはできません。先着順です。
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<InputString label="作家名" required={true} value={states.profile.owner_name} onChange={onChangeString("owner_name")} helper={OwnerNameLengthMin+'文字以上'+OwnerNameLengthMax+'文字以内'} opt={{minLength:OwnerNameLengthMin,maxLength:OwnerNameLengthMax}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						<Grid item xs={12} sm={3} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<Typography variant="h6">作家名（かな）<span className="formRequired">必須</span></Typography>
							<div className="formExplanation">
								読み方がわかるようにひらがなだけで入力してください
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<InputString label="作家名（かな）" required={true} value={states.profile.kana} onChange={onChangeString("kana")} regex="^[ぁ-んー　]*$" regexError="全角ひらがなだけで入力してください" helper={'全角ひらがな　'+OwnerNameLengthMin+'文字以上'+OwnerNameLengthMax+'文字以内'} opt={{minLength:OwnerNameLengthMin,maxLength:OwnerNameLengthMax}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						<Grid item xs={12} sm={3} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<Typography variant="h6">団体名</Typography>
							<div className="formExplanation">
								作家名とは別にサークル名などがある場合は入力してください
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<InputString label="団体名" required={false} value={states.profile.company_name} onChange={onChangeString("company_name")} helper={CompanyNameLengthMin+'文字以上'+CompanyNameLengthMax+'文字以内'} opt={{minLength:CompanyNameLengthMin,maxLength:CompanyNameLengthMax}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						<Grid item xs={12} sm={3} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<Typography variant="h6">紹介文</Typography>
							<div className="formExplanation">
								作家ページに表示される自己紹介テキストです
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<InputString label="紹介文" required={false} value={states.profile.profile} onChange={onChangeString("profile")} helper={Tools.comma(OwnerProfileLengthMax)+'文字以内'} opt={{rows:10,maxLength:OwnerProfileLengthMax}}/>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						<Grid item xs={12} sm={3} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<Typography variant="h6">SNS</Typography>
							<div className="formExplanation">
								お客さんに公開しても大丈夫なSNSのアカウントがありましたらアカウント名を入力してください<br/>
								<br/>
								※<b>マストドン</b>と<b>ミスキー</b>はURLで入力してください<br/>
								（例）https://radio.mstdn.jp/@quaqoostore<br/>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<Grid container spacing={2}>
								<Grid item xs={12} sm={6}>
									<InputString label="ツイッター(X)" convert={stripurl} required={false} value={snss.twitter} onChange={onChangeSnss("twitter")} opt={{minLength:SnsAccountLengthMin,maxLength:SnsAccountLengthMax,opt:'ツイッターのアカウント',startAdornment: (<TwitterIcon/>)}}/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<InputString label="フェイスブック" convert={stripurl} required={false} value={snss.facebook} onChange={onChangeSnss("facebook")} opt={{minLength:SnsAccountLengthMin,maxLength:SnsAccountLengthMax,opt:'フェイスブックのアカウント',startAdornment: (<FacebookIcon/>)}}/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<InputString label="インスタグラム" convert={stripurl} required={false} value={snss.instagram} onChange={onChangeSnss("instagram")} opt={{minLength:SnsAccountLengthMin,maxLength:SnsAccountLengthMax,opt:'インスタグラムのアカウント',startAdornment: (<InstagramIcon/>)}}/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<InputString label="タンブラー" convert={stripurl} required={false} value={snss.tumblr} onChange={onChangeSnss("tumblr")} opt={{minLength:SnsAccountLengthMin,maxLength:SnsAccountLengthMax,opt:'タンブラーのアカウント',startAdornment: (<TumblrIcon/>)}}/>
								</Grid>
								<Grid item xs={12} sm={12}>
									<InputString label="マストドン" regex="^https://" regexError="URLで入力してください（https://から）" required={false} value={snss.mastodon} onChange={onChangeSnss("mastodon")} opt={{minLength:SnsAccountLengthMin,maxLength:FediverseAccountLengthMax,opt:'マストドンのURL',startAdornment: (<MastodonIcon/>)}}/>
								</Grid>
								<Grid item xs={12} sm={12}>
									<InputString label="ミスキー" regex="^https://" regexError="URLで入力してください（https://から）" required={false} value={snss.misskey} onChange={onChangeSnss("misskey")} opt={{minLength:SnsAccountLengthMin,maxLength:FediverseAccountLengthMax,opt:'ミスキーのURL',startAdornment: (<MisskeyIcon/>)}}/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<InputString label="スレッズ" convert={stripurl} required={false} value={snss.threads} onChange={onChangeSnss("threads")} opt={{minLength:SnsAccountLengthMin,maxLength:SnsAccountLengthMax,opt:'スレッズのアカウント',startAdornment: (<ThreadsIcon/>)}}/>
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						<Grid item xs={12} sm={3} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<Typography variant="h6">リンク</Typography>
							<div className="formExplanation">
								個人サイトや他店の販売ページなど自由にどうぞ
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
						{states.params.links.map((data:Dataset,index:number)=>{
							const key = "link"+index;
							const name1 = "リンク先"+(index+1);
							const name2 = "URL";
							return (
								<TwinInputString key={key} value1={data.id} value2={data.label} name1={name1} name2={name2} maxLength1={100} maxLength2={300} placeholder1="サイトやSNSのタイトル" placeholder2="https://～" regex2="^https?:\/\/" change={changeParamTwin} id="links" index={index}/>
							)
						})}
							{states.paramErrors.indexOf('links')>=0 &&
							<div className="formError" style={{marginTop:'-1em'}}>文字数オーバーまたは入力が不完全な項目があります</div>
							}
							<Button variant="outlined" color="primary" style={{marginTop:'0.5em'}} size="small" onClick={addBlankLink} disabled={states.params.links.length>3}><AddIcon/> リンクを追加</Button>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
						<Grid item xs={12} sm={3} md={4} sx={{paddingRight: {xs:'0',md:'1em'}}}>
							<Typography variant="h6">追加画像</Typography>
							<div className="formExplanation">
								作家ページに表示される画像です<br/>
								<div className="formHint">
									※PNG/JPEG/GIFで、3枚まで登録できます<br/>
									※JPEGに変換して保存されます<br/>
									※幅1280pxより大きい場合は自動的に縮小されます<br/>
								</div>
							</div>
						</Grid>
						<Grid item xs={12} sm={9} md={8}>
							<div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
								{states.profile.photo_ids.map((img_id:number,index:number)=>{
									const key = "photo"+String(index+1);
									const name = "追加画像" + String(index+1);
									return (
										<div key={key} style={{ flex: '0 0 auto', width: '100px', height: '75px' }}>
											<DropImageLight noHelper={true} owner_id={props.ownerId} img_id={img_id} data={states.newImgs[key]} name={name} id={key} change={changeImage}/>
										</div>
									);
								})}
							</div>
							<div className="formHelper" style={{marginTop:'1em'}}>
								画像を登録するには「ここに追加」をクリックもしくは画像をドラッグして下さい<br/>
							</div>
						</Grid>
						<Grid item xs={12}>
							<Divider className="formValidator"/>
						</Grid>
					</Grid>
					<div style={{maxWidth:'300px',marginLeft:'auto',marginTop:'2em',backgroundColor:'#F0F0F0',padding:'1em',boxSizing:'border-box'}}>
						{props.ownerId>0 &&
						<>
                        <RowData name="作家ID" value={String(props.ownerId)} height={true}/>
						<RowData name="取扱開始日" value={states.profile.start_date} height={true}/>
						<RowData name="最終納品日" value={states.profile.last_consign} height={true}/>
						<RowData name="最終売上日" value={states.profile.last_sale} height={true}/>
						</>}
						<div style={{position:"relative"}}>
							<div style={{position:"absolute",top:"0",left:"0",width:"40%"}}>状態</div>
							<div style={{marginLeft:"40%",textAlign:"right"}}>
								{Tools.colorLabel("owner_status",states.owner.status,states.profile.status_label)}
							</div>
						</div>
					</div>
			</div>
			</DialogContent>
            <Yesno mes={states.yesno} yes={yes} no={no} isOpen={states.yesno!==""}/>
			<Problems names={states.problems} yes={yes} no={no} isOpen={states.problems.length>0}/>
            <Toast mes={states.toast} close={closeToast}/>
		</Dialog>
	);
}

export default ProfileInput;
